<template>
  <dev>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>修改密码</el-breadcrumb-item>
    </el-breadcrumb>
    
    <el-form :model="password" ref="form" label-width="85px" size="small">
      <el-form-item label="原密码">
        <el-input v-model="password.oldPassword" style="width: 30%;" placeholder="20位内字母数字下划线"></el-input>
      </el-form-item>
      <el-form-item label="新密码">
        <el-input v-model="password.newPassword" style="width: 30%;" placeholder="20位内字母数字下划线"></el-input>
      </el-form-item>
      <el-form-item label="确认新密码">
        <el-input v-model="password.newPasswordCheck" style="width: 30%;" placeholder="20位内字母数字下划线"></el-input>
      </el-form-item>
      <el-form-item size="large">
        <el-button type="primary" @click="onSubmit">提交</el-button>
      </el-form-item>
    </el-form>
    
  </dev>
</template>

<script>
  export default {
    data() {
      return {
        password: {
          oldPassword: "",
          newPassword: "",
          newPasswordCheck: ""
        },
      }
    },
    methods: {
        async onSubmit() {
          if( !this.check(this.password.oldPassword) || !this.check(this.password.newPassword) || !this.check(this.password.newPasswordCheck))
          {
            return;
          }
          
          if(this.password.newPassword !== this.password.newPasswordCheck)
          {
            alert("新密码和确认新密码不一致 ");
            return;
          }
          //console.log(this.password);
          
          const {data:res} = await this.$http.post('/api/user/changePassword/'+window.localStorage.getItem('userId')+'/'+this.password.oldPassword+'/'+this.password.newPassword)
          if (res.code==1){
              this.$message({
              message:res.msg,
              type:'success'
            })
          }
        },
        check(value)
        {
          if(value == "")
          {
            alert("不能为空");
            return false;
          }
          
          var regular = /^[0-9a-zA-Z_]{1,}$/
          if(!regular.test(value))
          {
            alert("只能使用字母数字下划线");
            return false;
          }
          
          return true;
          
        }
    }
  }
</script>

<style>
</style>